import { h } from 'preact';

const WolficonSearch = () => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 617 576"><path d="M438.17,451.15,323,334.94A145.94,145.94,0,0,0,199.69,110.6,144.41,144.41,0,0,0,96.61,153,143,143,0,0,0,53.16,256.11c0,39.42,15.16,75.79,43.45,104.09a145.93,145.93,0,0,0,181.9,19.2l115.2,115.2ZM131,324.83a96.37,96.37,0,0,1,0-136.42c18.19-19.2,42.44-28.3,68.72-28.3s50.52,9.1,68.71,28.3A96.82,96.82,0,0,1,131,324.83Z"/><rect x="489" y="128" width="64" height="64"/><rect x="489" y="256" width="64" height="64"/><rect x="489" y="384" width="64" height="64"/></svg>
);

export default WolficonSearch;
